import { render, staticRenderFns } from "./vPaginate.vue?vue&type=template&id=4298aa24"
import script from "./vPaginate.vue?vue&type=script&lang=js"
export * from "./vPaginate.vue?vue&type=script&lang=js"
import style0 from "./vPaginate.vue?vue&type=style&index=0&id=4298aa24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports